import { render } from "./HomeView2.vue?vue&type=template&id=1dbea548&scoped=true"
import script from "./HomeView2.vue?vue&type=script&lang=js"
export * from "./HomeView2.vue?vue&type=script&lang=js"

import "./HomeView2.vue?vue&type=style&index=0&id=1dbea548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbea548"]])

export default __exports__